import { IconButton, InputAdornment, Paper, TextField, Typography, withStyles } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { useEffect } from 'react'
import Email from '../assets/email.svg';
import BgRight from '../assets/bg_right.svg';
import Bg from '../assets/Bg.svg';
import Character from '../assets/character login.png';
import LogoLogin from '../assets/LogoLogin.png';
import Welcome from '../assets/welcome.png';
import Username from '../assets/ic_un.png';
import Password from '../assets/ic_pass.png';
import { useHistory } from 'react-router-dom';
import Constant from '../library/Constant';
import api from './api';

const InputBaru = withStyles({
    root: {
        '& .MuiInputBase-input': {
            fontFamily: 'Poppins',
            fontSize: '1.7vh',
            fontWeight: '500',
            boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-input': {
            padding: '2vh 1vh'
        },
        '& input:-internal-autofill-selected': {
            backgroundColor: 'transparent'
        },

        // MuiInputBase: {
        //     root: {
        //         fontFamily: 'Poppins',
        //     },
        //     input: {
        //         fontFamily: 'Poppins',
        //         fontSize: '12vh',
        //         boxSizing: 'border-box'
        //     }
        // }
    }
})(TextField);

const inputStyle = { WebkitBoxShadow: "0 0 0 1000px white inset" };


export default function Login(props) {
    const history = useHistory()
    const [showPass, setShowPass] = React.useState(false)
    const [email, setEmail] = React.useState("")
    const [password, setPassword] = React.useState("")
    const [error, setError] = React.useState("")

    const handleLogin = () => {
        let payload = {
            "email": email,
            "password": password
        }
        api.create().login(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    // localStorage.setItem(Constant.ACCESS_TOKEN, "TOKEN")
                    localStorage.setItem(Constant.ACCESS_TOKEN, response.data.data.access_token)
                    localStorage.setItem(Constant.REFRESH_TOKEN, response.data.data.refresh_token)
                    history.push('/')
                } else {
                    if (response.data.data) {
                        if (response.data.data.email) {
                            // alert(response.data.data.email)
                            setError(response.data.data.email)
                        } else if (response.data.data.password) {
                            // alert(response.data.data.password)
                            setError(response.data.data.password)
                        } else {
                            setError(response.data.data)
                        }
                    } else {
                        setError(response.data.message)
                        // alert(response.data.message)
                    }
                }
            }
        })
    }

    return (
        <div className="login-container">
            <img className='bg-login' src={BgRight} style={{ position: 'absolute', right: 0, width: '47%' }} />
            <img className='bg-login' src={Bg} style={{ position: 'absolute', left: '2%', bottom: 0, width: '42%' }} />
            <div className="login-form">
                {/* <img src={LogoLogin} className="login-logo-carolus" /> */}
                <div style={{ display: 'flex' }}>
                    <img src={localStorage.getItem(Constant.LOGO_RS)} style={{ height: 80, width: 65, marginRight: 20 }} />
                    <div className='text-logo' style={{ alignSelf: 'center' }}>
                        <Typography style={{ fontSize: 46, fontWeight: 'bold', color: 'white', lineHeight: 1 }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
                        <Typography style={{ fontSize: 20, fontWeight: '300', color: 'white' }}>{localStorage.getItem(Constant.DESCRIPTION_RS)}</Typography>
                    </div>
                </div>
                <div>
                    <span className="login-welcome-text">Welcome To Web Admin !</span>
                </div>
                {/* <img src={Welcome} style={{ height: '6%', width: '75%', marginTop: '3%' }} /> */}
                <div className="login-logo-welcome bg-login">
                    <img src={Character} style={{ height: '60%', width: '50%', zIndex: 100, contain: 'layout' }} />
                </div>
            </div>
            <form
                className="login-form-paper"
                onSubmit={(e) => {
                    e.preventDefault()
                    handleLogin()
                }}
            >
                <div style={{ height: '100%', display: 'grid', justifyItems: 'center', alignItems: 'center', textAlign: '-webkit-center' }}>
                    <div className="login-paper">
                        {/* <img src={BoxLogin} style={{ width: '100%', contain: 'layout' }}/> */}
                        <Typography className="login-akun-anda">Login Akun Anda</Typography>
                        {error !== "" ?
                            <Typography className='error-text'>{error}</Typography>
                            : null}
                        <InputBaru
                            className='input-email'
                            id="username"
                            type={"text"}
                            name={"username"}
                            placeholder={'Username/Email'}
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value)
                                setError("")
                            }}
                            variant="outlined"
                            style={{}}
                            // helperText={msgEmail}
                            InputProps={{
                                style: { borderRadius: 30, backgroundColor: 'white', borderColor: '#278863', fontSize: '1.5vh', borderStyle: 'solid', maxHeight: 50, padding: 0, },
                                startAdornment: <InputAdornment position="end" style={{ marginRight: '5%', marginLeft: '5%', height: '10%' }}><img src={Username} style={{ height: '3vh' }} /></InputAdornment>,
                            }}
                            InputLabelProps={{
                                style: {
                                    marginLeft: '15%', fontSize: '1.5vh',
                                    padding: 0
                                }
                            }}
                        />
                        <InputBaru
                            id="password"
                            type={showPass ? 'text' : 'password'}
                            name={"password"}
                            placeholder={'Password'}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value)
                                setError("")
                            }}
                            variant="outlined"
                            onSubmit={() => handleLogin()}
                            style={{ width: '80%', fontSize: '1.5vh', borderRadius: 30, marginTop: '7%', padding: 0 }}
                            InputProps={{
                                style: { borderRadius: 30, backgroundColor: 'white', borderColor: '#278863', fontSize: '1.5vh', borderStyle: 'solid', maxHeight: 50, padding: 0, },
                                startAdornment: <InputAdornment position="end" style={{ marginRight: '5%', marginLeft: '5%', }}><img src={Password} style={{ height: '3vh' }} /></InputAdornment>,
                                endAdornment: <InputAdornment position="end" style={{ marginRight: '5%' }}>
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        style={{ color: '#4b4b4b', opacity: 0.5, outline: 'none', margin: 0, padding: 0 }}
                                        onClick={() => setShowPass(!showPass)}
                                        edge="end"
                                    >
                                        {showPass ? <Visibility style={{ height: '3vh' }} /> : <VisibilityOff style={{ height: '3vh' }} />}
                                    </IconButton>
                                </InputAdornment>,
                            }}
                            InputLabelProps={{
                                style: {
                                    marginLeft: '15%', fontSize: '1.5vh',
                                    padding: 0
                                }
                            }}
                        />
                        <div style={{ cursor: 'pointer' }}
                            onClick={() => {
                                history.push('/forgot-pass')
                            }}>
                            <Typography className='text-forgot-pass' style={{  }}>Lupa Kata Sandi</Typography>
                        </div>
                        <button
                            style={{ outline: 'none', borderColor: 'transparent', height: '8%', width: '50%', backgroundColor: '#278863', borderRadius: 30, marginTop: '7%', cursor: 'pointer' }}
                        >
                            <Typography className='text-button-login' style={{  }}>Login</Typography>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}